export const EQUIP_TITLE_STATUS_NOT_REVIEWED = 'N,X,I';
export const EQUIP_TITLE_STATUS_REVIEWED = 'Z';
export const EQUIP_TITLE_STATUS_PROCESSING = 'Y,3';
export const EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE = 'D,G';
export const EQUIP_TITLE_STATUS_READY_FOR_SALE = 'R,K';
export const EQUIP_TITLE_STATUS_IN_TRANSIT = 'M,J';
export const EQUIP_TITLE_STATUS_NOT_TRANSFERABLE = '4,5';
export const EQUIP_TITLE_STATUS_TRANSFERABLE = '6,7';
export const EQUIP_TITLE_STATUS_TRANSFERRED = 'S,Q';

export const EQUIP_TITLE_STATUS_NOT_REVIEWED_DESC = 'TITLE NEW';
export const EQUIP_TITLE_STATUS_REVIEWED_DESC = 'TITLE REVIEWED';
export const EQUIP_TITLE_STATUS_PROCESSING_DESC = 'TITLE PROCESSING';
export const EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE_DESC = 'TITLE VERIFIED';
export const EQUIP_TITLE_STATUS_READY_FOR_SALE_DESC = 'TITLE READY FOR SALE';
export const EQUIP_TITLE_STATUS_IN_TRANSIT_DESC = 'TITLE IN TRANSIT';
export const EQUIP_TITLE_STATUS_NOT_TRANSFERABLE_DESC = 'TITLE NOT TRANSFERABLE';
export const EQUIP_TITLE_STATUS_TRANSFERABLE_DESC = 'TITLE TRANSFERABLE';
export const EQUIP_TITLE_STATUS_TRANSFERRED_DESC = 'TITLE TRANSFERRED';

export const titleStatusType = [
  { id: EQUIP_TITLE_STATUS_NOT_REVIEWED, description: EQUIP_TITLE_STATUS_NOT_REVIEWED_DESC  },
  { id: EQUIP_TITLE_STATUS_REVIEWED, description: EQUIP_TITLE_STATUS_REVIEWED_DESC  },
  { id: EQUIP_TITLE_STATUS_PROCESSING, description: EQUIP_TITLE_STATUS_PROCESSING_DESC  },
  { id: EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE, description: EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE_DESC  },
  { id: EQUIP_TITLE_STATUS_READY_FOR_SALE, description: EQUIP_TITLE_STATUS_READY_FOR_SALE_DESC  },
  { id: EQUIP_TITLE_STATUS_IN_TRANSIT, description: EQUIP_TITLE_STATUS_IN_TRANSIT_DESC  },
  { id: EQUIP_TITLE_STATUS_NOT_TRANSFERABLE, description: EQUIP_TITLE_STATUS_NOT_TRANSFERABLE_DESC  },
  { id: EQUIP_TITLE_STATUS_TRANSFERABLE, description: EQUIP_TITLE_STATUS_TRANSFERABLE_DESC  },
  { id: EQUIP_TITLE_STATUS_TRANSFERRED, description: EQUIP_TITLE_STATUS_TRANSFERRED_DESC  }
  ];

export enum TitleStatusNameType {
  New = 'New',
  Reviewed = 'Reviewed',
  Processing = 'Processing',
  Verified = 'Verified',
  ReadyForSale = 'Ready for Sale',
  TitleInTransit = 'Title in Transit',
  NotTransferable = 'Not Transferable',
  Transferable = 'Transferable',
  Transferred = 'Transferred'
}

